import { CheckboxProps } from "antd/es/checkbox"
import CheckboxStyle from "./CheckBox.style"

function CheckBox(props: CheckboxProps) {
  const { children, ...prop } = props
  return <CheckboxStyle {...prop}>{children}</CheckboxStyle>
}

export default CheckBox
